import { SettingsForm, type FieldSpec } from "../SettingsForm.js";

const FIELDS: FieldSpec[] = [
  { kind: "group", label: "Unternehmen" },
  { kind: "text", key: "companyName", label: "Firmenname", placeholder: "ELMETIC GmbH" },
  { kind: "textarea", key: "address", label: "Adresse", rows: 2, placeholder: "Straße, PLZ Ort" },
  { kind: "text", key: "uid", label: "UID-Nummer", placeholder: "ATU…" },
  { kind: "text", key: "firmenbuchnummer", label: "Firmenbuchnummer", placeholder: "FN … x" },

  { kind: "group", label: "Kontakt" },
  { kind: "text", key: "contactPerson", label: "Ansprechpartner" },
  { kind: "text", key: "phone", label: "Telefonnummer" },
  { kind: "text", key: "email", label: "E-Mail", placeholder: "office@example.at" },
  { kind: "text", key: "website", label: "Website", placeholder: "https://…" },

  { kind: "group", label: "Dokument-Branding" },
  { kind: "text", key: "logoUrl", label: "Logo-URL", help: "Wird in Angeboten, Konzepten und PDF-Ausgaben verwendet." },
  { kind: "text", key: "letterheadUrl", label: "Briefpapier-URL" },
  { kind: "textarea", key: "signatureBlock", label: "Signaturblock", rows: 4, help: "Erscheint am Ende von Berichten und Angeboten." },
];

export function FirmenprofilSection() {
  return (
    <SettingsForm
      category="company"
      title="Firmenprofil"
      intro="Stammdaten des Unternehmens. Diese Daten werden für Angebote, Konzepte, Berichte und PDF-Ausgaben verwendet."
      fields={FIELDS}
    />
  );
}
